import { FLYBITS } from '../../../constants';
import axios from '../../../utils/axios';

export const updateKey = async (accessToken: string, tenantId: string, key: string): Promise<any> => {
    const response = await axios.post(FLYBITS.AUTH_HOST + `/api-key`, {
        tenant_id: tenantId,
        issuer: 'sensibill',
        key,
    }, {
        headers: {
            Authorization: accessToken,
        },
        validateStatus: (status: number) => true,
    });
    return response.data
}

export const getKey = async (accessToken: string, tenantId: string): Promise<any> => {
    const response = await axios.get(FLYBITS.AUTH_HOST + `/api-key/${tenantId}/sensibill`, {
        headers: {
            Authorization: accessToken,
        },
        validateStatus: (status: number) => true,
    });
    return (200 === response.status) ? response.data : {}
}




// WEBPACK FOOTER //
// ./src/sub-projects/sensibill/services/auth.ts